import { computed, getCurrentInstance, watch, type Plugin } from "vue";
import { useMeta } from "vue-meta";

type Metadata = Record<string, any>;

// vue-meta's Options API plugin checks isProxy instead of isRef for computed data.
// Pass only the computed value to its manager, keeping ref internals out of metadata.
const metaPlugin: Plugin = {
  install(app) {
    app.mixin({
      created() {
        const instance = getCurrentInstance();
        const options = instance?.type as
          | { metaInfo?: Metadata | (() => Metadata) }
          | undefined;
        const source = options?.metaInfo;
        if (!source) return;
        if (typeof source !== "function") {
          useMeta(source);
          return;
        }

        const getMetadata = source as () => Metadata;
        const resolved = computed(() => getMetadata.call(this));
        const { meta } = useMeta(resolved.value);
        watch(resolved, (value) => {
          for (const key of Object.keys(meta)) {
            if (!(key in value)) delete meta[key];
          }
          Object.assign(meta, value);
        }, { deep: true });
      },
    });
  },
};

export default metaPlugin;
